module.exports = __webpack_public_path__ + "files/a17f74b99200b1f22679952cba32a093.png";